import {TableCell, Link} from '@material-ui/core';
import compiler from '../../view/Fields';
//import { Link } from 'react-router-dom';


export default function available_fields(view_fields) {

    const extract_duration = (seconds) => {
        let labels = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'];
        let values  = [
                31557600,
                2629800,
                60 * 60 * 24,
                60 * 60,
                60,
                1
        ];
        let out = [];
        if(seconds < 0) out.push('-');
        let sec = Math.abs(seconds);
        for(let n in values){
            let val = Math.floor(sec / values[n]);
            if(val){
                out.push(val+' '+labels[n]);
                sec-= val * values[n];
            }
            if(sec <= 0) break;
        }
        return out.join(', ');
    }
    const round = (number, precision) => {
        let prec = precision || 1;
        let comp = Math.pow(10, prec);
        return Math.round(number * comp) / comp;
    }

    const getSize = (bytes) => {
        if(!bytes) return '';
        if(bytes < 1024) return [bytes, 'bytes'].join(' ');
        if(bytes < 1024 * 1024) return [round(bytes / 1024), 'kb'].join('');
        if(bytes < 1024 * 1024 * 1024) return [round(bytes / 1024 / 1024), 'mb'].join('');
        return [round(bytes / 1024 / 1024 / 1024), 'gb'].join('');
    }

    const getProcessTime = (dateval) => {
        var dt = new Date(dateval);
        let addmins = 60 - dt.getMinutes();
        return new Date(dt.valueOf() + addmins * 60 * 1000);
    }

    const fields = [{
        name : 'id',
        label : 'File ID',
        type : 'HIDDEN'
    }, {
        name : 'entry_date',
        label : 'Uploaded',
        type : 'DATETIME'
    }, {
        name : 'offset_seconds',
        label : 'Time offset',
        type : 'INT',
        render : (row) => {
            //let [seconds, minutes, hours, days, months, years] = [1]
            return (<TableCell>{extract_duration(row.offset_seconds)}</TableCell>);
        }
    }, {
        name : 'finish_date',
        label : 'Processed',
        type : 'DATETIME',
        compileValue : (row) => {
            if(row.active === 0) return row.finish_date;
            return getProcessTime(row.entry_date);
            //return null;
        }
    }, {
        name : 'duration',
        label : 'Processing time',
        type : 'INT',
        render : (row) => {
            return (<TableCell>{extract_duration(row.duration)}</TableCell>);
        }
    }, {
        name : 'path',
        label : 'File',
        render : (row) => {
            let folder = row.path.split('/');
            let filename = folder.pop();
            //return(<TableCell>{filename}</TableCell>);
            
            return (
            <TableCell 
                component={Link} 
                href={"http://www.forteltraffic.com/needs/vspeedOnline/"+row.path}
                target="_blank"
            >{filename}</TableCell>
            );
            
        }
    }, {
        name : 'sign_id',
        label : 'Sign',
        type : 'HIDDEN'
    }, {
        name : 'active',
        label : 'Status',
        type : 'INT',
        render : (row) => {
            let stats = [
                'Complete',
                'Queued',
                'Processing',
                'Pending'
            ]
            return (
                <TableCell>{stats[row.active]}</TableCell>
            );
        }
    }, {
        name : 'type',
        label : 'Type'
    }, {
        name : 'size',
        label : 'Size',
        type : 'INT',
        render : (row) => {
            return (
                <TableCell>{getSize(row.size)}</TableCell>
            )
        }
    }, {
        name : 'fdate',
        label : 'Record start date',
        type : 'DATETIME',
        
    }, {
        name : 'tdate',
        label : 'Record end date',
        type : 'DATETIME'
    }];

    const compileField = compiler(fields);
    
    if(view_fields){
        return view_fields.map(compileField);
    }
    return fields.map(compileField);
    
}